import { render, staticRenderFns } from "./BasePrintIcon.vue?vue&type=template&id=b45d25da"
import script from "./BasePrintIcon.vue?vue&type=script&lang=js"
export * from "./BasePrintIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports